<ubb-sidenav>
    <ubc-sidebar sidebar [navigation]="navigationData">
        <ng-container ubcNavigation>
            <ubc-navigation-menu [menuData]="APP_NAVIGATION"/>
        </ng-container>
    </ubc-sidebar>
    <ng-container topbar>
        <ubb-breadcrumb/>
        <div>
            <app-alerts-menu/>
            <app-language-selector/>
            <app-topbar-user-button/>
        </div>
    </ng-container>
    <router-outlet/>
</ubb-sidenav>

